import API from 'utils/API'

export const fetchCategories = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/category${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createCategory = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/category', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deleteCategory = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/category/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchCategoryDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/category/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateCategory = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/category/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
